"use client"

import { useEffect } from "react"

const GA_ID = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID
const GOOGLE_ANALYTICS_INITIALIZATION_DELAY_MS = 15_000

type GoogleAnalyticsWindow = Window & {
  dataLayer?: unknown[][]
  gtag?: (...args: unknown[]) => void
}

/**
 * Queues and loads GA4 after the critical rendering/interaction window.
 * A plain lazyOnload script still ran during Lighthouse and added a 200ms+
 * main-thread task, so the loader uses an explicit post-load delay.
 */
export function GoogleAnalyticsScript() {
  useEffect(() => {
    if (!GA_ID) return

    const timer = window.setTimeout(() => {
      const analyticsWindow = window as GoogleAnalyticsWindow
      analyticsWindow.dataLayer ??= []
      analyticsWindow.gtag ??= (...args: unknown[]) => {
        analyticsWindow.dataLayer?.push(args)
      }

      analyticsWindow.gtag("js", new Date())
      analyticsWindow.gtag("config", GA_ID, {
        page_path: window.location.pathname,
        send_page_view: true,
      })

      if (document.getElementById("gtag-js")) return
      const script = document.createElement("script")
      script.id = "gtag-js"
      script.async = true
      script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`
      document.head.appendChild(script)
    }, GOOGLE_ANALYTICS_INITIALIZATION_DELAY_MS)

    return () => window.clearTimeout(timer)
  }, [])

  return null
}
